import React, { useMemo } from "react";
import Mou from "./Mou";
import AnnualReports from "./AnnualReports";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import {
  setPowerTabStr,
  setReportsTabStr,
} from "../../../redux/slice/sliceHome";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useLocation } from "react-router-dom";
import useSeo from "../../../hooks/useSeo";

const ReportPage = () => {
  const { getText } = useLanguageTranslation();
  const { reportTabStr, languageType } = useSelector(
    (state) => state.homeSlice
  );

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });
  const dispatch = useDispatch();

  const { data: getReportTableData = [], isLoading: getReportTableIsLoading } =
    useGetProtectedApiDataQuery({ url: "reports", lang: languageType });

  const annualReports = getReportTableData.filter(
    (report) =>
      report.field_equity_category ===
      getText("Annual Report", "वार्षिक रिपोर्ट")
  );

  console.log({ annualReports });

  const mouReports = getReportTableData.filter(
    (report) => report.field_equity_category === getText("MOU", "एमओयू")
  );

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(getReportTableData)?.changed
    );
  }, [getReportTableData]);

  if (getReportTableIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/reports"
        levelTwo={false}
        levelThree={false}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                {/* <!--menu section start here--> */}
                <section className="leftmenu-hori">
                  <ul>
                    <li
                      className={
                        reportTabStr === "annual-report" ? "active" : ""
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // setActiveTab("annual-report");
                          dispatch(setReportsTabStr("annual-report"));
                        }}
                      >
                        <div className="icon icon-annual-report"></div>
                        {getText("Annual Reports", "वार्षिक रिपोर्ट")}
                      </a>
                    </li>
                    <li className={reportTabStr === "mou" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // setActiveTab("mou");
                          dispatch(setReportsTabStr("mou"));
                        }}
                      >
                        <div className="icon icon-mou"></div>
                        {getText("MOU", "एमओयू")}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
            <div>
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>

            {reportTabStr === "annual-report" && (
              <AnnualReports data={annualReports} />
            )}
            {reportTabStr === "mou" && <Mou data={mouReports} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportPage;
